import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import CustomAlert from "./components/alert/CustomAlert";

const options = {
  position: positions.TOP_RIGHT,
  timeout: 4000,
  offset: "24px 24px",
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 999999,
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AlertProvider template={CustomAlert} {...options}>
    <App />
  </AlertProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
